import DoseList from './DoseList';
import ImageList from './ImageList';
import RegistrationList from './RegistrationList';
import StructureSetList from './StructureSetList';
import UnloadedDatasetList from './UnloadedDatasetList';

export default function DatasetList() {
    return (
        <>
            <ImageList />
            <StructureSetList />
            <DoseList />
            <RegistrationList />
            <UnloadedDatasetList />
        </>
    );
}
